import { AnyAction } from 'redux'
import { createSelector } from 'reselect'
import type { State } from 'shared/types/gallery/state'

const initialState: State.FilterCategoryState = {}

export function reducer(state: State.FilterCategoryState = initialState, action: AnyAction): State.FilterCategoryState {
  switch (action.type) {
    default:
      return state
  }
}

export const categoryByIdSelector = createSelector(
  (state: State.GlobalState) => state.filterCategories,
  (filterCategories) =>
    (categoryId: string): State.Category =>
      filterCategories[categoryId],
)

export const taxonomyIdByCategoryIdSelector = createSelector(
  (state: State.GlobalState) => state.taxonomyIdByCategoryId,
  (taxonomyIdByCategoryId) =>
    (categoryId: string): string =>
      taxonomyIdByCategoryId[categoryId],
)
